/**
 * 订单接口
 * 
 * @author 杨斌
 * @since 2019-11-04
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口
/**
 * 获取卡包列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getPrizeCount = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/lottery/presentShred/activity.json', p, okCb, failCb)
}

// 用于显示隐藏转盘的， 俺也不知道叫什么
ApiList.getLotteryActive = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/lottery/active.json', p, okCb, failCb)
}




export default ApiList;



// WEBPACK FOOTER //
// ./src/api/lottery-api.js